import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
// import TestScreen from './components/TestScreen';
import Board from './containers/Board/Board';
import Dashboard from './containers/Dashboard';
import Cards from './containers/Cards';
import CardDetails from './containers/CardDetails';
import ModalRoute from './components/ModalRoute';

const AppRoutes = () => {
  const location = useLocation();
  const { state } = location;
  const isModalRoute = !!state?.backgroundLocation;

  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        {/*
        <Route
          path="/test-screen"
          element={<TestScreen />}
        />
        */}
        <Route
          path="/"
          element={<App />}
        >
          <Route
            path=":boardId"
            element={
              <Board
                isHeaderTitleHidden={isModalRoute}
                isTrackingBarShown={!isModalRoute}
              />
            }
          >
            <Route
              index
              element={<Dashboard />}
            />
            <Route
              path="cards"
              element={<Cards />}
            />
            <Route
              path="mycards"
              element={<Cards isMyOnly />}
            />
            <Route
              path="cards/:cardId"
              element={<CardDetails />}
            />
          </Route>
        </Route>
      </Routes>
      {/* https://reactrouter.com/docs/en/v6/examples/modal */}
      {/* Show the modal when a `backgroundLocation` is set */}
      {isModalRoute && (
        <Routes>
          <Route
            path="/"
            element={
              <ModalRoute>
                <App />
              </ModalRoute>
            }
          >
            <Route
              path=":boardId"
              element={<Board isHeaderTitleHidden />}
            >
              <Route
                path="cards/:cardId"
                element={<CardDetails />}
              />
            </Route>
          </Route>
          {/*<Route*/}
          {/*  path=":boardId/cards/:cardId"*/}
          {/*  element={*/}
          {/*    <ModalRoute>*/}
          {/*      <App>*/}
          {/*        <Board isHeaderTitleHidden>*/}
          {/*          <CardDetails />*/}
          {/*        </Board>*/}
          {/*      </App>*/}
          {/*    </ModalRoute>*/}
          {/*  }*/}
          {/*/>*/}
        </Routes>
      )}
    </>
  );
};

export default AppRoutes;
